import React from 'react';
import { useSpaceState } from '../hooks/useSpaceState';
import { SpaceHeader } from '../components/SpaceHeader';
import { ConversationStream } from '../components/ConversationStream';
import { MessageInput } from '../components/MessageInput';
import { ContextSidebar } from '../components/ContextSidebar';
import { NavigationSidebar } from '../components/NavigationSidebar';
export function SpacePage() {
  const {
    state,
    activeSpaceId,
    selectSpace,
    sendMessage,
    confirmAction,
    skipAction,
    toggleSidebar,
    toggleActivityDetails,
    messagesEndRef
  } = useSpaceState();
  return <div className="flex h-screen bg-white overflow-hidden font-sans text-gray-900" data-id="element-253">
      {/* Left Navigation Sidebar */}
      <NavigationSidebar activeSpaceId={activeSpaceId} onSelectSpace={selectSpace} data-id="element-254" />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 bg-white h-full" data-id="element-255">
        <SpaceHeader name={state.name} status={state.status} onToggleSidebar={toggleSidebar} sidebarOpen={state.sidebarOpen} data-id="element-256" />

        <main className="flex flex-1 overflow-hidden relative" data-id="element-257">
          <div className="flex-1 flex flex-col min-w-0 bg-white" data-id="element-258">
            <ConversationStream messages={state.messages} onConfirmAction={confirmAction} onSkipAction={skipAction} onToggleActivityDetails={toggleActivityDetails} bottomRef={messagesEndRef} data-id="element-259" />
            <MessageInput onSend={sendMessage} isTyping={state.isTyping} data-id="element-260" />
          </div>

          <ContextSidebar files={state.files} isOpen={state.sidebarOpen} onToggle={toggleSidebar} data-id="element-261" />
        </main>
      </div>
    </div>;
}